import {
    CREATE_KNITTING_INWARD_DETAILS_FAILURE_DK,
    CREATE_KNITTING_INWARD_DETAILS_REQUEST_DK,
    CREATE_KNITTING_INWARD_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_KNITTING_INWARD_DETAILS_DK,
    DELETE_KNITTING_INWARD_DETAILS_FAILURE_DK,
    DELETE_KNITTING_INWARD_DETAILS_REQUEST_DK,
    DELETE_KNITTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_KNITTING_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_KNITTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_KNITTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_KNITTING_INWARD_DETAILS_FAILURE_DK,
    FETCH_KNITTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_KNITTING_INWARD_DETAILS_SUCCESS_DK,
    KNITTING_INWARD_DETAILS_USERFORM_RESET_DK,
    UPDATE_KNITTING_INWARD_DETAILS_FAILURE_DK,
    UPDATE_KNITTING_INWARD_DETAILS_REQUEST_DK,
    UPDATE_KNITTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_KNITTING_INWARD_DETAILS_BY_ID_REQUEST_DK,
    FETCH_KNITTING_INWARD_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_FAILURE_DK,
    KNITTING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK
} from './knittingInwardDetails.actionsType';

export const KNITTING_INWARD_DETAILS_DK = 'knittingInwardDetailsDK';

let initialState = {
    loading: false,
    knittingInwardDetailsById: [],
    isDcDetailDisabled: false,
    knittingInwardDetails: [],
    previousGetList: [],
    knittingInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldReceivingRolls: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedKnittingDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let knittingInwardDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_KNITTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_KNITTING_INWARD_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_KNITTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_KNITTING_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_KNITTING_INWARD_DETAILS_REQUEST_DK:
        case DELETE_KNITTING_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_KNITTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case FETCH_KNITTING_INWARD_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsById: updatePayload
            };

        case CREATE_KNITTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isDcDetailDisabled: false
            };
        case FETCH_SINGLE_KNITTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedKnittingDetails: updatePayload,
                knittingInwardDetailsForm: { ...updatePayload }
            };
        case UPDATE_KNITTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedKnittingDetails: {},
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isDcDetailDisabled: false
            };
        case DELETE_KNITTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedKnittingDetails: {},
                isDcDetailDisabled: false
            };

        case FETCH_KNITTING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_KNITTING_INWARD_DETAILS_FAILURE_DK:
        case CREATE_KNITTING_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_KNITTING_INWARD_DETAILS_FAILURE_DK:
        case DELETE_KNITTING_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_INWARD_DETAILS_DK:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsForm: {
                    ...state.knittingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case KNITTING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK:
            return {
                ...state,
                isDcDetailDisabled: payload
            };
        case KNITTING_INWARD_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isDcDetailDisabled: false,
                selectedKnittingDetails: {}
            };
        default:
            return state;
    }
};
